import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import EditCounselor from "./EditCounselor";

const EditCounselorLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Edit Counselor" />
      <EditCounselor />
    </MasterLayout>
  );
};

export default EditCounselorLayout;
